import React from 'react';

export default function Footer() {
    return (
        <footer className="footer mt-3 py-3 bg-light">
            <div className="container">
                <span className="text-muted">Place sticky footer content here.</span>
            </div>
        </footer>
    )
}
